<div class="container">
      <section class="inner-container">
        <main>
              <section style="background-image: url(images/register-bg-2000.jpg)" data-parallax="full" class="product-detail-banner">
                <div class="caption center-full">
                  <div class="inner">
                    <h2>Register</h2>
                  </div>
                </div>
              </section>
          <div class="contact-form">
            <div class="row">
              <div class="col-md-7">
                <form style="margin-left: 3em; margin-top: 3em; padding-right: 6em" name="register-form" id="register-form" data-k2-validation="true" novalidate class="general-form">
                  <h5 class="title-form">Personal Details</h5>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="group">
                            <input type="text" name="first-name" id="first-name" [(ngModel)]="user.first_name" placeholder="" class="custom-input" required data-rules="required" data-error-mes="This field is required" trim="blur">
                        <label>First Name</label>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="group">
                            <input type="text" name="last-name" id="last-name" [(ngModel)]="user.last_name" placeholder="" class="custom-input" required data-rules="required" data-error-mes="This field is required" trim="blur">
                        <label>Last Name</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="group">
                        <input type="text" name="email" id="email" placeholder="" [(ngModel)]="user.email" class="custom-input" required data-rules="required|email" data-error-mes="This field is required|Email is invalid" trim>
                        <label>E-mail</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="group">
                            <input (change)="checkPassword()" type="password" name="password" id="password" [(ngModel)]="user.password" placeholder="" class="custom-input" required data-rules="required|password" data-error-mes="This field is required|Password must contain at least 8 characters, including at least 1 number AND at least 1 uppercase letter.">
                        <label>Password</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="group">
                            <input (change)="checkPassword()" type="password" name="confirmPassword" id="confirmPassword" [(ngModel)]="confirmPassword" placeholder="" class="custom-input" required data-rules="required" data-error-mes="This field is required">
                        <label>Confirm Password</label>
                      </div>
                      <div *ngIf="(user.password != confirmPassword) && user.password?.length>7" class="red">
                          Passwords must match
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                        <div class="group" [innerHTML]="captcha">
                        </div>
                        
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                        
                        <p>This question is to prevent automated spam submissions. Entries are not case sensitive.</p>
                        <div class="group">
                        <a (click)="getCaptcha()" class="btn btn-default btn-block btn-checklist pointer bg-white" >REFRESH</a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="group">
                        <input type="text" name="captcha" id="captcha" placeholder="" [(ngModel)]="user['bot']" class="custom-input" required data-rules="required" data-error-mes="This field is required" trim>
                        <label>Captcha</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-7">
                        <div class="checkbox-default">
                          <label for='tc'> 
                            <input type="checkbox" id='tc' [(ngModel)]="tcAgree" #tc="ngModel" name="tc" required data-rules="required" data-error-mes="This field is required"><span></span>
                            I agree to the <a class="yellow" href="assets/tnc.pdf" target="_blank">terms and conditions</a>
                          </label>
                        </div>
                        <div *ngIf="!valid && !tcAgree" class="red" style="padding-top: 1em">
                            This must be ticked
                        </div>
                    </div>
                    <div class="col-md-5">
                      <button type="submit" class="btn btn-primary btn-block" (click)="validate()">Sign Up</button>
                    </div>
                  </div>
                  <div class="row" style="margin-bottom: 3ch">
                    <div class="col-md-12">
                      Already have an account? <a routerLink="/login"><u>Sign In</u></a>.
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-5">
                <ul class="more-contact-info">
                  <li>
                    <p class="text-medium"><strong>General Banking Enquiries / Customer Service</strong></p>
                    <p>Customer Care Hotline:<br><a href="tel:1300 88 6688" title="1-300 88 6688 (Malaysia)">1-300 88 6688 (Malaysia)</a><br><a href="tel:+603 7844 3696" title="+603-7844 3696 (Overseas)">+603-7844 3696 (Overseas)</a><br><a href="mailto:mgcc@maybank.com.my" title="Email: mgcc@maybank.com.my">Email: mgcc@maybank.com.my</a>
                    </p>
                    <p class="txt-grey">Operating Hours: 24 hours (That includes holidays.)</p>
                  </li>
                  <!-- <li>
                    <p class="text-medium"><strong>Head Office / Registered Office / Registrar</strong></p>
                    <p>Malayan Banking Berhad<br>Level 14, Menara Maybank<br>100 Jalan Tun Perak<br>50050 Kuala Lumpur, Malaysia<br>Contact:<a href="tel:+603 2070 8833" title="+603-2070 8833">+603-2070 8833</a>
                    </p>
                  </li> -->
                  <li>
                    <p class="text-medium"><strong>Credit Card Centre</strong></p>
                    <p>For enquiries, call<a href="tel:130088 6688" title="1-300-88 6688"><strong>1-300-88 6688</strong></a>&nbsp; or fax our Credit Card Centre at<a href="tel:037953 8610" title="03-7953 8610"> <strong>03-7953 8610</strong></a>&nbsp; (Platinum/Premier) or<a href="tel:037953 8600" title="03-7953 8600"><strong> 03-7953 8600</strong></a>&nbsp; (General/Gold &amp; Classic).
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </main>
      </section>
    </div>
